import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";

const Tarifas = (props) => {
  document.title = "Tarifas | Listado - Ges Sindical";

  const breadcrumbItems = [
    { title: "Tarifas", link: "#" },
    { title: "Listado", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Tarifas', breadcrumbItems);
  }, []);

  const [tarifas, setTarifas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editando, setEditando] = useState(null);
  const [nombre, setNombre] = useState('');
  const [monto, setMonto] = useState('');
  const [status, setStatus] = useState(true);

  // Traer tarifas al iniciar
  const fetchTarifas = () => {
    setLoading(true);
    fetch('https://asijeminapis.website:5248/api/rates')
      .then(res => res.json())
      .then(data => {
        setTarifas(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchTarifas();
  }, []);

  // --- Alta / Edición ---
  const abrirFormNueva = () => {
    setEditando(null);
    setNombre('');
    setMonto('');
    setStatus(true);
    setShowForm(true);
  };

  const abrirFormEditar = (tarifa) => {
    setEditando(tarifa._id);
    setNombre(tarifa.name);
    setMonto(tarifa.amount);
    setStatus(tarifa.status !== false);
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!nombre || !monto || isNaN(Number(monto))) {
      Swal.fire({ icon: 'warning', title: 'Complete todos los campos correctamente.' });
      return;
    }
    setLoading(true);

    if (editando) {
      // Edición
      try {
        const res = await fetch(`https://asijeminapis.website:5248/api/rates/${editando}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: nombre, amount: Number(monto), status }),
        });
        if (res.ok) {
          Swal.fire({ icon: 'success', title: 'Tarifa actualizada.' });
          setShowForm(false);
          fetchTarifas();
        } else {
          Swal.fire({ icon: 'error', title: 'Error al editar tarifa.' });
        }
      } catch {
        Swal.fire({ icon: 'error', title: 'Error de red.' });
      }
    } else {
      // Alta
      try {
        const res = await fetch('https://asijeminapis.website:5248/api/rates', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: nombre, amount: Number(monto), status }),
        });
        if (res.ok) {
          Swal.fire({ icon: 'success', title: 'Tarifa creada.' });
          setShowForm(false);
          fetchTarifas();
        } else {
          Swal.fire({ icon: 'error', title: 'Error al crear tarifa.' });
        }
      } catch {
        Swal.fire({ icon: 'error', title: 'Error de red.' });
      }
    }
    setLoading(false);
  };

  // --- Activar/Desactivar ---
  const handleToggleStatus = (tarifa) => {
    Swal.fire({
      title: tarifa.status !== false ? '¿Desactivar tarifa?' : '¿Activar tarifa?',
      text: tarifa.status !== false
        ? 'La tarifa no se podrá asignar mientras esté desactivada.'
        : 'La tarifa estará disponible para socios.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: tarifa.status !== false ? 'Desactivar' : 'Activar'
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const res = await fetch(`https://asijeminapis.website:5248/api/rates/${tarifa._id}/status`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ status: !tarifa.status })
          });
          if (res.ok) {
            Swal.fire({ icon: 'success', title: tarifa.status !== false ? 'Tarifa desactivada.' : 'Tarifa activada.' });
            fetchTarifas();
          } else {
            Swal.fire({ icon: 'error', title: 'Error al actualizar estado.' });
          }
        } catch {
          Swal.fire({ icon: 'error', title: 'Error de red.' });
        }
        setLoading(false);
      }
    });
  };

  return (
    <div className="container mt-4">
      <h2>Tarifas</h2>
      <button className="btn btn-success mb-3" onClick={abrirFormNueva}>+ Nueva Tarifa</button>

      {loading && <p>Cargando...</p>}

      {!loading && tarifas.length > 0 && (
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Monto</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tarifas.map(t => (
              <tr key={t._id} style={{ opacity: t.status === false ? 0.5 : 1 }}>
                <td>{t.name}</td>
                <td>${t.amount}</td>
                <td>
                  {t.status !== false
                    ? <span className="badge bg-success">Activa</span>
                    : <span className="badge bg-danger">Inactiva</span>}
                </td>
                <td>
                  <button className="btn btn-sm btn-primary me-2" onClick={() => abrirFormEditar(t)}>
                    Editar
                  </button>
                  <button
                    className={`btn btn-sm ${t.status !== false ? 'btn-warning' : 'btn-success'}`}
                    onClick={() => handleToggleStatus(t)}
                  >
                    {t.status !== false ? 'Desactivar' : 'Activar'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Formulario Alta/Edición */}
      {showForm && (
        <div className="modal show" style={{ display: "block", background: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <form className="modal-content" onSubmit={handleSubmit}>
              <div className="modal-header">
                <h5 className="modal-title">{editando ? "Editar Tarifa" : "Nueva Tarifa"}</h5>
                <button type="button" className="btn-close" onClick={() => setShowForm(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label>Nombre</label>
                  <input type="text" className="form-control" value={nombre} onChange={e => setNombre(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label>Monto</label>
                  <input type="number" className="form-control" value={monto} onChange={e => setMonto(e.target.value)} required />
                </div>
                <div className="mb-3">
                  <label>
                    <input type="checkbox" checked={status} onChange={e => setStatus(e.target.checked)} />
                    {' '}Tarifa activa
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {editando ? "Actualizar" : "Crear"}
                </button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {!loading && tarifas.length === 0 && <p>No hay tarifas registradas.</p>}
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(Tarifas);
